import './styles/segmented-bar.css';

export default function SegmentedBar({ segments, label }) {
    const total = segments.reduce((sum, segment) => sum + segment.value, 0);
    const description = segments
        .filter((segment) => segment.value > 0)
        .map((segment) => `${segment.label}: ${segment.value}`)
        .join(', ');

    return (
        <div className="segmented-bar" role="img" aria-label={`${label}. ${description || 'Sin datos'}`}>
            {total === 0 && <span className="segmented-bar__empty" />}
            {segments.filter((segment) => segment.value > 0).map((segment) => (
                <span
                    key={segment.key}
                    className={`segmented-bar__segment segmented-bar__segment--${segment.tone}`}
                    style={{ flexGrow: segment.value }}
                />
            ))}
        </div>
    );
}
